
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class SectionHeading extends Vue {
  @Prop({ default: "title here" }) readonly title!: string;
}
